function infoCarouselHeight() {
    const height = $('.infoCarousel__slide[data-slick-index="0"]').outerHeight();
    document.documentElement.style.setProperty('--infoCarouselHeight', "".concat(height, "px"));
};

if ($('#infoCarousel').length) {
    $('#infoCarousel__slides').on('init', function () {
        infoCarouselHeight();
    });

    $('#infoCarousel__slides').slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        centerMode: false,
        mobileFirst: true
    });

    $( window ).on('resize', function() {
        setTimeout(function () {
            infoCarouselHeight();
        }, 300);
    });
}